import Vue from 'vue';

const success = (context, response) => {
  $(".cancel").removeClass("disabled");
  $(".confirm").removeClass("disabled");
  swal(context.$t("booking.creation_popup.success.title"), context.$t("booking.creation_popup.success.text"), 'success');
  toastr.success(response.msg);
  this.loading = false;
  Vue.router.push({
    name: 'bookings.index',
  });
};

const failed = (context, error) => {
  context.loading = false;
  if (error.response.data.includeOverride) {
    $(".cancel").removeClass("disabled");
    $(".confirm").removeClass("disabled");
    context.showIncludeOverrideModal(error.response.data.msg);
  } else {
    context.showToasterError(error);
  }
};

export default (context, data) => {
  return Vue.$http.post('/bookings', data).then((response) => {
    if (response && response.status === 200) {
      success(context, response.data);
    }
  }).catch((error) => {
    failed(context, error);
  });
}



// WEBPACK FOOTER //
// ./src/app/services/booking/store.js